// extracted by mini-css-extract-plugin
module.exports = {"canvas":"LogicalCanvas_canvas__C6FHF","content":"LogicalCanvas_content__P7ViW","overlay":"LogicalCanvas_overlay__jbsQf"};